export default __webpack_public_path__ + "static/media/LisaSimpson.a414a02c.png";